module.exports = {
    ANDROID_APP_LINK: 'https://play.google.com/store/apps/details?id=com.neoin'
}